import React from 'react';
import '../styles/app.css';
import { createRoot } from 'react-dom/client';
import Hello from './controllers/Hello';
import PasswordSecurityInfo from './controllers/PasswordSecurityInfo';
import Registration from './controllers/Registration';
import ObjetTrouve from './controllers/ObjetTrouve';
import EditObjectModal from './components/EditObjectModal';
import ObjetTrouveNew from './controllers/ObjetTrouveNew';
import ObjetTrouveEdit from './controllers/ObjetTrouveEdit';
import ReclamationForm from './controllers/ReclamationForm';
import ModerationImageModule from './controllers/ModerationImageModule';
import LitigeModal from './controllers/LitigeModal';
import LitigeForm from './controllers/LitigeForm';
import CompleteProfile from './controllers/CompleteProfile';
import RestitutionModal from './controllers/RestitutionModal';
import ReclamationActions from './controllers/ReclamationActions';

const components = {
    Hello,
    PasswordSecurityInfo,
    Registration,
    ObjetTrouve,
    EditObjectModal,
    ObjetTrouveNew,
    ObjetTrouveEdit,
    ReclamationForm,
    ModerationImageModule,
    LitigeModal,
    LitigeForm,
    CompleteProfile,
    RestitutionModal,
    ReclamationActions
};

document.addEventListener('DOMContentLoaded', () => {
    // Support both custom data-react-component and Symfony UX React attributes
    const elements = document.querySelectorAll('[data-react-component], [data-symfony--ux-react--react-component-value]');

    elements.forEach(el => {
        const componentName = el.getAttribute('data-react-component') || el.getAttribute('data-symfony--ux-react--react-component-value');
        console.log(`Found React element for component: ${componentName}`);
        const Component = components[componentName];
        if (Component) {
            console.log(`Component ${componentName} found in registry, rendering...`);
            const propsJson = el.getAttribute('data-react-props') || el.getAttribute('data-symfony--ux-react--react-props-value') || '{}';
            try {
                const props = JSON.parse(propsJson);
                const root = createRoot(el);
                root.render(<Component {...props} />);
                console.log(`Component ${componentName} rendered successfully.`);
            } catch (e) {
                console.error(`Error parsing props for component ${componentName}:`, e);
            }
        } else {
            console.warn(`Component ${componentName} not found in registry! Available components:`, Object.keys(components));
        }
    });
});
